import React, { useState, useEffect } from 'react';
import { register } from './glitchScheduler';

const css = `
.gp-wrap {
  position: relative;
  display: inline-block;
  line-height: 1;
  user-select: none;
}

.gp-char {
  display: block;
  text-align: center;
}

.gp-scan {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 1px,
    rgba(0,0,0,0.08) 1px,
    rgba(0,0,0,0.08) 2px
  );
  pointer-events: none;
  animation: gpScanDrift 0.5s linear infinite;
}

@keyframes gpScanDrift {
  from { background-position: 0 0; }
  to { background-position: 0 2px; }
}

@keyframes gpGlitchMain {
  0%   { opacity: 1; transform: translate(0); }
  20%  { opacity: 0.8; transform: translate(2px, 0); }
  40%  { opacity: 1; transform: translate(-2px, 0); }
  60%  { opacity: 0.9; transform: translate(1px, 0); }
  80%  { opacity: 1; transform: translate(-1px, 0); }
  100% { opacity: 1; transform: translate(0); }
}

@keyframes gpGlitchTop {
  0%   { transform: translate(0); }
  20%  { transform: translate(-3px, 0); }
  40%  { transform: translate(3px, 0); }
  60%  { transform: translate(-1px, 0); }
  80%  { transform: translate(2px, 0); }
  100% { transform: translate(0); }
}

@keyframes gpGlitchBot {
  0%   { transform: translate(0); }
  20%  { transform: translate(3px, 0); }
  40%  { transform: translate(-3px, 0); }
  60%  { transform: translate(1px, 0); }
  80%  { transform: translate(-2px, 0); }
  100% { transform: translate(0); }
}
`;

let styleInjected = false;

const GlitchPiece = ({ piece, size = 18, color = '#ffd700', intensity = 1 }) => {
  const [glitching, setGlitching] = useState(false);

  useEffect(() => {
    const unregister = register(() => {
      setGlitching(true);
      setTimeout(() => setGlitching(false), 350);
    });
    return unregister;
  }, []);

  if (!styleInjected && typeof document !== 'undefined') {
    const tag = document.createElement('style');
    tag.textContent = css;
    document.head.appendChild(tag);
    styleInjected = true;
  }

  const anim = glitching ? 'gpGlitchMain 0.35s ease-out' : 'none';
  const animTop = glitching ? 'gpGlitchTop 0.35s ease-out' : 'none';
  const animBot = glitching ? 'gpGlitchBot 0.35s ease-out' : 'none';

  return (
    <span className="gp-wrap" style={{ fontSize: size, color, width: size, height: size }}>
      <span className="gp-char" style={{
        animation: anim,
        textShadow: `0 0 ${3 * intensity}px ${color}`,
      }}>
        {piece}
        <span style={{
          position: 'absolute', top: 0, left: 0, width: '100%',
          color: '#ff4466',
          opacity: glitching ? 0.7 : 0.5,
          clipPath: 'inset(0 0 50% 0)',
          animation: animTop,
          transition: 'opacity 0.15s',
        }}>{piece}</span>
        <span style={{
          position: 'absolute', top: 0, left: 0, width: '100%',
          color: '#0066ff',
          opacity: glitching ? 0.65 : 0.45,
          clipPath: 'inset(50% 0 0 0)',
          animation: animBot,
          transition: 'opacity 0.15s',
        }}>{piece}</span>
        <span style={{
          position: 'absolute', top: 0, left: 0, width: '100%',
          color: '#ffd700',
          opacity: 0.7,
          clipPath: 'inset(47% 0 47% 0)',
        }}>{piece}</span>
      </span>
      <span className="gp-scan" style={{ mixBlendMode: 'overlay' }}></span>
    </span>
  );
};

export default GlitchPiece;
